import { render, staticRenderFns } from "./KeywordSpotting.vue?vue&type=template&id=2d93382f&"
import script from "./KeywordSpotting.vue?vue&type=script&lang=ts&"
export * from "./KeywordSpotting.vue?vue&type=script&lang=ts&"
var disposed = false

function injectStyles (context) {
  if (disposed) return
  var style0 = require("./KeywordSpotting.vue?vue&type=style&index=0&id=2d93382f&lang=scss&")
if (style0.__inject__) style0.__inject__(context)

}


  module.hot && module.hot.dispose(function (data) {
    disposed = true
  })

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  ,true
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/actions-runner/_work/mfe-ca-wizard/mfe-ca-wizard/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d93382f')) {
      api.createRecord('2d93382f', component.options)
    } else {
      api.reload('2d93382f', component.options)
    }
    module.hot.accept("./KeywordSpotting.vue?vue&type=template&id=2d93382f&", function () {
      api.rerender('2d93382f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/KeywordSpotting.vue"
export default component.exports